module.exports = __webpack_public_path__ + "static/media/galerija_2022_0007.838d74e4.jpg";